export interface MoneyUtilParams {
  moneyFormat: string;
  moneyFormatWithCurrency: string;
}

export interface MoneyFormatOptions {
  withCurrency?: boolean;
  withoutTrailingZeros?: boolean;
}

export class MoneyUtil {
  moneyFormat: string;
  moneyFormatWithCurrency: string;
  placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  constructor(params: MoneyUtilParams) {
    this.moneyFormat = params.moneyFormat ?? "${{amount}}";
    this.moneyFormatWithCurrency =
      params.moneyFormatWithCurrency ?? "${{amount}} USD";
  }

  formatMoney(cents: number | string, options?: MoneyFormatOptions) {
    const withCurrency = options?.withCurrency ?? false;

    if (typeof cents === "string") {
      cents = parseInt(cents.replace(".", ""));
    }

    const formattedValue = this.formatCents(
      cents,
      this.moneyFormat.match(this.placeholderRegex)?.[1],
      options?.withoutTrailingZeros,
    );

    return (
      withCurrency ? this.moneyFormatWithCurrency : this.moneyFormat
    ).replace(this.placeholderRegex, formattedValue);
  }

  formatCents(cents: number, format?: string, withoutTrailingZeros?: boolean) {
    switch (format) {
      case "amount_no_decimals":
        return this.formatWithDelimiters(cents, 0);
      case "amount_with_comma_separator":
        if (withoutTrailingZeros) {
          return this.formatWithDelimiters(cents, 2, ".", ",").replace(
            ",00",
            "",
          );
        }
        return this.formatWithDelimiters(cents, 2, ".", ",");
      case "amount_no_decimals_with_comma_separator":
        return this.formatWithDelimiters(cents, 0, ".", ",");
      case "amount":
      default:
        if (withoutTrailingZeros) {
          return this.formatWithDelimiters(cents, 2).replace(".00", "");
        }
        return this.formatWithDelimiters(cents, 2);
    }
  }

  formatWithDelimiters(
    cents: number,
    precision = 2,
    thousands = ",",
    decimal = ".",
  ) {
    if (isNaN(cents) || cents == null) {
      return "0";
    }

    const amount = (cents / 100.0).toFixed(precision);
    const parts = amount.split(".");

    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`,
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }
}
